import { http } from '../../plugins/http';
import { getData } from '../../utils/get';

export default {

    /**
     * @returns {boolean}
     */
    authCheck() {
        return http.get('/api/authCheck').then(getData);
    },

    getSystemSettingPasswordReset() {
        return http.get('/api/password/system-setting').then(getData);
    }

};



// WEBPACK FOOTER //
// ./src/services/Auth/LoginController.js